//
import {
  CAMPUSVIRTUAL_SET_IDCAMPUS,
  CAMPUSVIRTUAL_SET_LISTACAMPI,
  CAMPUSVIRTUAL_SET_LISTACONFIGURACIONES,
  CAMPUSVIRTUAL_SET_AUTHENTICATEDUSER,
  CAMPUSVIRTUAL_UNSET_AUTHENTICATEDUSER,
  CAMPUSVIRTUAL_LOGOUT,
  CAMPUSVIRTUAL_GET_CARTERA,
  CAMPUSVIRTUAL_GET_CARTERA_SUCCESS,
  CAMPUSVIRTUAL_GET_CARTERA_FAIL,
  CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA,
  CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA_SUCCESS,
  CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA_FAIL,
  CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS,
  CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS_SUCCESS,
  CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS_FAIL,
  CAMPUSVIRTUAL_WAIT_FOR_PROPERTY_TO_CHANGE,
  CAMPUSVIRTUAL_GET_CAMPUS,
  CAMPUSVIRTUAL_GET_CAMPUS_SUCCESS,
  CAMPUSVIRTUAL_GET_CAMPUS_FAIL,
  CAMPUSVIRTUAL_GET_CARRERAS,
  CAMPUSVIRTUAL_GET_CARRERAS_SUCCESS,
  CAMPUSVIRTUAL_GET_CARRERAS_FAIL,
  CAMPUSVIRTUAL_GET_PLANES,
  CAMPUSVIRTUAL_GET_PLANES_SUCCESS,
  CAMPUSVIRTUAL_GET_PLANES_FAIL,
  CAMPUSVIRTUAL_GET_TURNOS,
  CAMPUSVIRTUAL_GET_TURNOS_SUCCESS,
  CAMPUSVIRTUAL_GET_TURNOS_FAIL,
  CAMPUSVIRTUAL_GET_TRAYECTORIAS,
  CAMPUSVIRTUAL_GET_TRAYECTORIAS_SUCCESS,
  CAMPUSVIRTUAL_GET_TRAYECTORIAS_FAIL,
  CAMPUSVIRTUAL_GET_STATUS,
  CAMPUSVIRTUAL_GET_STATUS_SUCCESS,
  CAMPUSVIRTUAL_GET_STATUS_FAIL,
  CAMPUSVIRTUAL_GET_CONFIGURACION,
  CAMPUSVIRTUAL_GET_CONFIGURACION_SUCCESS,
  CAMPUSVIRTUAL_GET_CONFIGURACION_FAIL,
  CAMPUSVIRTUAL_GET_INGRESOSEGRESOS,
  CAMPUSVIRTUAL_GET_INGRESOSEGRESOS_SUCCESS,
  CAMPUSVIRTUAL_GET_INGRESOSEGRESOS_FAIL,
  CAMPUSVIRTUAL_GET_DATASEGMENTOS,
  CAMPUSVIRTUAL_GET_DATASEGMENTOS_SUCCESS,
  CAMPUSVIRTUAL_GET_DATASEGMENTOS_FAIL,
  CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS,
  CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS_SUCCESS,
  CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS_FAIL,
  CAMPUSVIRTUAL_POST_SENDTEMPLATE,
  CAMPUSVIRTUAL_POST_SENDTEMPLATE_SUCCESS,
  CAMPUSVIRTUAL_POST_SENDTEMPLATE_FAIL,
  CAMPUSVIRTUAL_SET_MESSAGE_SUCCESS,
  CAMPUSVIRTUAL_UNSET_MESSAGE_SUCCESS,
  CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL,
  CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL_SUCCESS,
  CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL_FAIL,
  CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD,
  CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD_SUCCESS,
  CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD_FAIL,
} from "./actionTypes"

export const getCampusVirtualResumenPuntualidad = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualResumenPuntualidadSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD_SUCCESS,
  payload: { data },
})
export const getCampusVirtualResumenPuntualidadFail = error => ({
  type: CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD_FAIL,
  payload: error,
})

export const setCampusVirtualMensajeExito = mensajeExitoso => ({
  type: CAMPUSVIRTUAL_SET_MESSAGE_SUCCESS,
  payload: { mensajeExitoso },
})

export const unsetCampusVirtualMensajeExito = () => ({
  type: CAMPUSVIRTUAL_UNSET_MESSAGE_SUCCESS,
})

export const postCampusVirtualSendLinkPagoEmail = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL,
    payload: { jsonparameters },
  }
}
export const postCampusVirtualSendLinkPagoEmailSuccess = data => ({
  type: CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL_SUCCESS,
  payload: { data },
})
export const postCampusVirtualSendLinkPagoEmailFail = error => ({
  type: CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL_FAIL,
  payload: error,
})

export const postCampusVirtualSendTemplate = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_POST_SENDTEMPLATE,
    payload: { jsonparameters },
  }
}
export const postCampusVirtualSendTemplateSuccess = data => ({
  type: CAMPUSVIRTUAL_POST_SENDTEMPLATE_SUCCESS,
  payload: { data },
})
export const postCampusVirtualSendTemplateFail = error => ({
  type: CAMPUSVIRTUAL_POST_SENDTEMPLATE_FAIL,
  payload: error,
})

export const getCampusVirtualDatasegmentos = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_DATASEGMENTOS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualDatasegmentosSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_DATASEGMENTOS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualDatasegmentosFail = error => ({
  type: CAMPUSVIRTUAL_GET_DATASEGMENTOS_FAIL,
  payload: error,
})

export const getCampusVirtualAlumnosSegmentados = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualAlumnosSegmentadosSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualAlumnosSegmentadosFail = error => ({
  type: CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS_FAIL,
  payload: error,
})

export const getCampusVirtualIngresosEgresos = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_INGRESOSEGRESOS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualIngresosEgresosSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_INGRESOSEGRESOS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualIngresosEgresosFail = error => ({
  type: CAMPUSVIRTUAL_GET_INGRESOSEGRESOS_FAIL,
  payload: error,
})

export const getCampusVirtualConfiguracion = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_CONFIGURACION,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualConfiguracionSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_CONFIGURACION_SUCCESS,
  payload: { data },
})
export const getCampusVirtualConfiguracionFail = error => ({
  type: CAMPUSVIRTUAL_GET_CONFIGURACION_FAIL,
  payload: error,
})

export const CampusVirtual_WaitForPropertyToChange = (property, resolver) => ({
  type: CAMPUSVIRTUAL_WAIT_FOR_PROPERTY_TO_CHANGE,
  property,
  resolver,
})

export const SetCampusVirtualIdCampus = id_Campus => ({
  type: CAMPUSVIRTUAL_SET_IDCAMPUS,
  payload: id_Campus,
})

export const SetCampusVirtualAuthenticatedUser = authenticatedUser => ({
  type: CAMPUSVIRTUAL_SET_AUTHENTICATEDUSER,
  payload: authenticatedUser,
})

export const unsetCampusVirtualAuthenticatedUser = () => ({
  type: CAMPUSVIRTUAL_UNSET_AUTHENTICATEDUSER,
  payload: authenticatedUser,
})

export const SetCampusVirtualListaCampi = listaCampi => ({
  type: CAMPUSVIRTUAL_SET_LISTACAMPI,
  payload: listaCampi,
})

export const SetCampusVirtualListaConfiguraciones = listaConfiguraciones => ({
  type: CAMPUSVIRTUAL_SET_LISTACONFIGURACIONES,
  payload: listaConfiguraciones,
})

export const SetCampusVirtualLogout = () => {
  console.log("export const SetCampusVirtualLogout")
  return {
    type: CAMPUSVIRTUAL_LOGOUT,
  }
}

export const getCampusVirtualCartera = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_CARTERA,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualCarteraSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_CARTERA_SUCCESS,
  payload: { data },
})
export const getCampusVirtualCarteraFail = error => ({
  type: CAMPUSVIRTUAL_GET_CARTERA_FAIL,
  payload: error,
})

export const getCampusVirtualCarteraComparativa = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualCarteraComparativaSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA_SUCCESS,
  payload: { data },
})
export const getCampusVirtualCarteraComparativaFail = error => ({
  type: CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA_FAIL,
  payload: error,
})

export const getCampusVirtualUltimosRecibos = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualUltimosRecibosSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualUltimosRecibosFail = error => ({
  type: CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS_FAIL,
  payload: error,
})

export const getCampusVirtualCampus = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_CAMPUS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualCampusSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_CAMPUS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualCampusFail = error => ({
  type: CAMPUSVIRTUAL_GET_CAMPUS_FAIL,
  payload: error,
})

export const getCampusVirtualCarreras = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_CARRERAS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualCarrerasSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_CARRERAS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualCarrerasFail = error => ({
  type: CAMPUSVIRTUAL_GET_CARRERAS_FAIL,
  payload: error,
})

export const getCampusVirtualPlanes = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_PLANES,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualPlanesSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_PLANES_SUCCESS,
  payload: { data },
})
export const getCampusVirtualPlanesFail = error => ({
  type: CAMPUSVIRTUAL_GET_PLANES_FAIL,
  payload: error,
})

export const getCampusVirtualTurnos = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_TURNOS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualTurnosSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_TURNOS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualTurnosFail = error => ({
  type: CAMPUSVIRTUAL_GET_TURNOS_FAIL,
  payload: error,
})

export const getCampusVirtualTrayectorias = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_TRAYECTORIAS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualTrayectoriasSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_TRAYECTORIAS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualTrayectoriasFail = error => ({
  type: CAMPUSVIRTUAL_GET_TRAYECTORIAS_FAIL,
  payload: error,
})

export const getCampusVirtualStatus = jsonparameters => {
  return {
    type: CAMPUSVIRTUAL_GET_STATUS,
    payload: { jsonparameters },
  }
}
export const getCampusVirtualStatusSuccess = data => ({
  type: CAMPUSVIRTUAL_GET_STATUS_SUCCESS,
  payload: { data },
})
export const getCampusVirtualStatusFail = error => ({
  type: CAMPUSVIRTUAL_GET_STATUS_FAIL,
  payload: error,
})
